//------------------
// CONFIG FILE FOR M.E MUSIC PLAYER
//------------------


// AE --------------
export const ae_redirect_url                   =  window.location.href + '/#/';
export const ae_form_ID                        = '50194';
export const ae_api_key                        = '42a58d7b9270aed820229d13ee3b753c';
export const ae_api_key_enc                    = '2c2d821370e91e5bcb432695e2fe002f907a9caa3cb14147fde38b46e54478f0';
export const ae_spotify_auth_url               = 'https://sme.theappreciationengine.com/brand/sony-music-canada/register/2493?return=' + ae_redirect_url;
export const ae_brand_ID                       = '3444296';
export const ae_segment_ID                     = '838917';
export const ae_default_mailinglist_ID         = 'a0S61000000b3FnEAI';

// NON AE ----------
export const spotify_client_key    = '9e6c8e78e7d94b2ebf6538ff9789e6af';
export const spotify_redirect_url  = window.location.href + '/#/';

// Apple
export const apple_developer_token = "eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6Ilc2QzI2OEwyUTYifQ.eyJpYXQiOjE1NjkyMzM5MTgsImV4cCI6MTU4NDc4NTkxOCwiaXNzIjoiRVdaREg0QzU1TSJ9.D0pfie4vJWlB8L5SdaeeqwmmrLI7U8Mvy1nOz7_w8VRWnqzgc3HUvY8M7NmUW6g7Q9rrMzRKjtu_fXO800ElmQ";
